/* eslint-disable */
import {ColorFilterDark020, ColorNeutral100} from '../../CSS Framework/src/js/variables'
function init (brandColors) {
    if (document.querySelector('#brandableTokens') !== null) {
      document.querySelector('#brandableTokens').remove()
    }
    let style = document.createElement('style')
    style.setAttribute('type', 'text/css')
    style.setAttribute('id', 'brandableTokens')
    style.innerHTML = renderStyles(brandColors.primary, brandColors.atRisk, brandColors.due, brandColors.urgent, brandColors.overdue, brandColors.success)
    document.head.appendChild(style)
  }
  
  function renderStyles (primary, atRisk, due, urgent, overdue, success) {
    
    const BrandColors = {
      primary: primary,
      primary10: hexToRGBAString(primary, 0.1),
      primary20: hexToRGBAString(primary, 0.2),
      atRisk: atRisk,
      due: due,
      urgent: urgent,
      overdue: overdue,
      success: success,
      brandFilterDark20Mix: blendColors(convertHexToRGBA(primary, 1), convertHexToRGBA(ColorFilterDark020, 0.1))
    }
    return `
      /* Buttons */
      .btn[ds-component="button"].brand {
          background-color: ${BrandColors.primary};
      }
      .btn[ds-component="button"].brand:hover {
          background-color: ${BrandColors.brandFilterDark20Mix};
      }
      .btn[ds-component="button"].brand:focus {
        background-color: ${BrandColors.brandFilterDark20Mix};
      }
      .btn[ds-component="button"].brand.loading {
        background-color: ${BrandColors.brandFilterDark20Mix};
      }
      /* Charm */
      .charm.colorful.brand button {
          background-color: ${BrandColors.primary10};
      }
      .charm.colorful.brand button:hover {
        background-color: ${BrandColors.primary20};
      }
      .charm.colorful.brand button:focus {
        background-color: ${BrandColors.primary};
      }
      .charm.colorful.brand button .icon::before {
        color: ${BrandColors.primary};
      }
      .charm.colorful.brand button:hover > .icon::before {
        color: ${BrandColors.primary};
      }
      .charm.colorful.brand button:focus > .icon::before {
        color: ${ColorNeutral100};
      }
      /*Checkboxes */
      .checkbox[ds-component="checkbox"].brand input:checked ~ .checkmark {
        background-color: ${BrandColors.primary};
      }
      .checkbox[ds-component="checkbox"].brand input:checked ~ .checkmark::after {
          background-color: ${BrandColors.primary10};
      }
      /* Choice Chips */
      .choice-chip[ds-component="choice-chip"] .choice-wrapper input:checked ~ .choice.brand {
        background: ${BrandColors.primary};
      }
      .choice-chip[ds-component="choice-chip"] .choice-wrapper input:checked:hover ~ .choice.brand {
        background: ${BrandColors.brandFilterDark20Mix};
      }
      /* Textfield */
      .text-field-group .text-field-wrapper .text-field.brand:focus {
        border: solid 1px ${BrandColors.primary};
      }
      .text-field-group.populated .text-field-wrapper .brand {
        background-color: ${BrandColors.primary10};
      }
      /* TextField telephone */
      .text-field-group[ds-component="textfield-phone"].populated.brand .text-field-wrapper .vue-tel-input  {
        background-color: ${BrandColors.primary10}
      }
      /* Basic Search */
      .basic-search.brand.active {
        border: 1px solid ${BrandColors.primary};
      }
      /* Dynamic Search */
      .filtered-search[ds-component="filtered-search"].brand.active {
        border: 1px solid ${BrandColors.primary};
      }
      /* Dropdown */
      .dropdown[ds-component="dropdown"].populated.brand .dropdown-heder {
        background: ${BrandColors.primary10};
      }
      .dropdown[ds-component="dropdown"].basic.active.brand .dropdown-heder, .dropdown[ds-component="dropdown"].combobox.active.brand .dropdown-heder, .dropdown[ds-component="dropdown"].populated.active.brand .dropdown-heder, .dropdown[ds-component="dropdown"].error.active.brand .dropdown-heder {
        border: 1px solid ${BrandColors.primary};
      }
      .dropdown[ds-component="dropdown"].basic.active.brand .dropdown-heder .drop-selector .drop-btn, .dropdown[ds-component="dropdown"].combobox.active.brand .dropdown-heder .drop-selector .drop-btn, .dropdown[ds-component="dropdown"].populated.active.brand .dropdown-heder .drop-selector .drop-btn, .dropdown[ds-component="dropdown"].error.active.brand .dropdown-heder .drop-selector .drop-btn {
        background: ${BrandColors.primary};
      }
      /* Menu */
      .menu[ds-component="menu"].basic.brand .menu-option-container .menu-option.selected, .menu[ds-component="menu"].icon.brand .menu-option-container .menu-option.selected {
        background-color: ${BrandColors.primary10};
      }
      .menu[ds-component="menu"].brand .menu-option-container .menu-option.selected .label-wrapper .icon {
        color: ${BrandColors.primary} !important;
      }
      /* Datepicker */
      .date-picker[ds-component="date-picker"] .text-field-wrapper.brand.active .trigger {
        background-color: ${BrandColors.primary};
      }
      .date-picker[ds-component="date-picker"].brand .vc-header .vc-title-layout .vc-title-wrapper .vc-title {
        color: ${BrandColors.primary};
      }
      .date-picker[ds-component="date-picker"].brand .vc-rounded-full {
        background-color: ${BrandColors.primary};
      }
      .date-picker[ds-component="date-picker"].brand .vc-highlight-base-start {
        background-color: ${BrandColors.primary20};
      }
      .date-picker[ds-component="date-picker"].brand .vc-highlight-base-end {
        background-color: ${BrandColors.primary20};
      }
      .date-picker[ds-component="date-picker"].brand .vc-highlight-base-middle {
        background-color: ${BrandColors.primary20};
      }
      /* Toggle Switch */
      .toggle-switch.brand input:checked ~ .switch-container {
        background-color: ${BrandColors.primary};
      }
      .toggle-switch.brand input:checked ~ .switch-container .switch-trigger .loading-icon svg path {
        fill:  ${BrandColors.primary};
      }
      .toggle-charm.brand input:checked:hover ~ .charm-container {
        background-color: ${BrandColors.primary20};
      }
      .toggle-charm.brand input:checked:hover ~ .charm-container .icon {
        color: ${BrandColors.primary};
      }
      /* Toggle Charm */
      .toggle-charm.brand input:checked ~ .charm-container {
        background-color: ${BrandColors.primary10};
      }
      .toggle-charm.brand input:checked ~ .charm-container .icon {
        color: ${BrandColors.primary};
      }
      .toggle-switch.brand input:checked:hover ~ .switch-container .switch-trigger {
        -webkit-box-shadow: 0px 0px 0px 10px ${BrandColors.primary10};
        box-shadow: 0px 0px 0px 10px ${BrandColors.primary10};
      }
      /* Tags */
      .tag[ds-component="tag"].bold.brand {
        background-color: ${BrandColors.primary};
      }
      .tag[ds-component="tag"].subtle.brand {
        background-color: ${BrandColors.primary10};
      }
      .tag[ds-component="tag"].subtle.brand .tag-label {
        color: ${BrandColors.primary};
      }
      .tag[ds-component="tag"].subtle.brand .icon::before {
        color: ${BrandColors.primary};
      }
      /* Button Group */
        /*text button group */
      .button-group[ds-component="button-group"].text.brand input:checked ~ .option {
        background-color: ${BrandColors.primary};
      }
      .button-group[ds-component="button-group"].text.brand input:checked:hover ~ .option {
        background-color: ${BrandColors.brandFilterDark20Mix};
      }
        /* icon button group */
      .button-group[ds-component="button-group"].icon.brand input:checked:hover ~ .option {
        background-color: ${BrandColors.primary20};
      }
      .button-group[ds-component="button-group"].icon.brand input:checked ~ .option .icon::before {
        color: ${BrandColors.primary};
      }
      .button-group[ds-component="button-group"].icon.brand input:checked ~ .option {
        color: ${BrandColors.primary};
        background-color: ${BrandColors.primary10};
      }
      /* text-icon button group */
      .button-group[ds-component="button-group"].icon-text.brand input:checked ~ .option {
        background-color: ${BrandColors.primary};
      }
        /* numberic button group */
      .button-group[ds-component="button-group"].numeric.brand input:checked ~ .option {
          color: ${BrandColors.primary};
          background-color: ${BrandColors.primary10};
      }
      .button-group[ds-component="button-group"].numeric.brand input:checked:hover ~ .option {
        background-color: ${BrandColors.primary20};
      }
      .button-group[ds-component="button-group"].numeric.brand input:checked ~ .option .numeric {
        color: ${BrandColors.primary};
      }
      /* Tabs */
      .tabs.brand .tab-wrapper input:checked ~ .tab {
        color: ${BrandColors.primary};
      }
      .tabs.brand {
        border-bottom-color: ${BrandColors.primary};
      }
      .btn.atrisk {
        background-color: ${BrandColors.atRisk};
      }
      .btn.due {
        background-color: ${BrandColors.due};
      }
      .btn.urgent {
        background-color: ${BrandColors.urgent};
      }
      .btn.overdue {
        background-color: ${BrandColors.overdue};
      }
      .btn.sucess {
        background-color: ${BrandColors.success};
      }
    `
  }
function colorValues (color) {
  if (!color) { return }
  if (color.toLowerCase() === 'transparent') { return [0, 0, 0, 0] }
  if (color[0] === '#') {
    if (color.length < 7) {
      // convert #RGB and #RGBA to #RRGGBB and #RRGGBBAA
      color = '#' + color[1] + color[1] + color[2] + color[2] + color[3] + color[3] + (color.length > 4 ? color[4] + color[4] : '')
    }
    return [parseInt(color.substr(1, 2), 16),
      parseInt(color.substr(3, 2), 16),
      parseInt(color.substr(5, 2), 16),
      color.length > 7 ? parseInt(color.substr(7, 2), 16) / 255 : 1]
  }
  if (color.indexOf('rgb') === -1) {
    // convert named colors
    var temp_elem = document.body.appendChild(document.createElement('fictum')) // intentionally use unknown tag to lower chances of css rule override with !important
    var flag = 'rgb(1, 2, 3)' // this flag tested on chrome 59, ff 53, ie9, ie10, ie11, edge 14
    temp_elem.style.color = flag
    if (temp_elem.style.color !== flag) { return } // color set failed - some monstrous css rule is probably taking over the color of our object
    temp_elem.style.color = color
    if (temp_elem.style.color === flag || temp_elem.style.color === '') { return } // color parse failed
    color = getComputedStyle(temp_elem).color
    document.body.removeChild(temp_elem)
  }
  if (color.indexOf('rgb') === 0) {
    if (color.indexOf('rgba') === -1) { color += ',1' } // convert 'rgb(R,G,B)' to 'rgb(R,G,B)A' which looks awful but will pass the regxep below
    return color.match(/[\.\d]+/g).map(function (a) {
      return +a
    })
  }
}
function hexValueToRgba (hexValue, opacity) {
  let rgba = 'rgba('
  colorValues(hexValue).forEach((m, index) => {
    index === 3 ? rgba += opacity + ')' : rgba += m + ', '
  })
  return rgba
}
var mix = function(color_1, color_2, weight) {
  function d2h(d) { return d.toString(16); }  // convert a decimal value to hex
  function h2d(h) { return parseInt(h, 16); } // convert a hex value to decimal 

  weight = (typeof(weight) !== 'undefined') ? weight : 50; // set the weight to 50%, if that argument is omitted

  var color = "#";

  for(var i = 0; i <= 5; i += 2) { // loop through each of the 3 hex pairs—red, green, and blue
    var v1 = h2d(color_1.substr(i, 2)), // extract the current pairs
        v2 = h2d(color_2.substr(i, 2)),
        
        // combine the current pairs from each source color, according to the specified weight
        val = d2h(Math.floor(v2 + (v1 - v2) * (weight / 100.0))); 

    while(val.length < 2) { val = '0' + val; } // prepend a '0' if val results in a single digit
    
    color += val; // concatenate val to our new color string
  }
    
  return color; // PROFIT!
}
const convertHexToRGBA = (hexCode, opacity) => { //works
  let hex = hexCode.replace('#', '');
  
  if (hex.length === 3) {
      hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }
  
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return [r, g, b, opacity]
  // return `rgba(${r},${g},${b},${opacity})`;
}
function hexToRGBAString(hexCode, opacity) {
  let r = convertHexToRGBA(hexCode, opacity)[0]
  let g = convertHexToRGBA(hexCode, opacity)[1]
  let b = convertHexToRGBA(hexCode, opacity)[2]
  let o = convertHexToRGBA(hexCode, opacity)[3]
  return `rgba(${r}, ${g}, ${b}, ${o})`
}
function RGBAToHexA(rgba) {
    let ex = /^rgba\((((((((1?[1-9]?\d)|10\d|(2[0-4]\d)|25[0-5]),\s?)){3})|(((([1-9]?\d(\.\d+)?)|100|(\.\d+))%,\s?){3}))|(((((1?[1-9]?\d)|10\d|(2[0-4]\d)|25[0-5])\s){3})|(((([1-9]?\d(\.\d+)?)|100|(\.\d+))%\s){3}))\/\s)((0?\.\d+)|[01]|(([1-9]?\d(\.\d+)?)|100|(\.\d+))%)\)$/i;
    if (ex.test(rgba)) {
        let sep = rgba.indexOf(",") > -1 ? "," : " ";
        rgba = rgba.substr(5).split(")")[0].split(sep);
        
        // strip the slash if using space-separated syntax
        if (rgba.indexOf("/") > -1)
            rgba.splice(3,1);

        for (let R in rgba) {
            let r = rgba[R];
            if (r.indexOf("%") > -1) {
                let p = r.substr(0,r.length - 1) / 100;

                if (R < 3) {
                    rgba[R] = Math.round(p * 255);
                } else {
                    rgba[R] = p;
                }
            }
        }

        let r = (+rgba[0]).toString(16),
            g = (+rgba[1]).toString(16),
            b = (+rgba[2]).toString(16),
            a = Math.round(+rgba[3] * 255).toString(16);
        
        if (r.length == 1)
            r = "0" + r;
        if (g.length == 1)
            g = "0" + g;
        if (b.length == 1)
            b = "0" + b;
        if (a.length == 1)
            a = "0" + a;
        
        return "#" + r + g + b + a;

    } else {
        return "Invalid input color";
    }
}
function blendColors(baseColor, addedColor) {
  var base = baseColor;
  var added = addedColor;

  var mix = [];
  mix[3] = 1 - (1 - added[3]) * (1 - base[3]); // alpha
  mix[0] = Math.round((added[0] * added[3] / mix[3]) + (base[0] * base[3] * (1 - added[3]) / mix[3])); // red
  mix[1] = Math.round((added[1] * added[3] / mix[3]) + (base[1] * base[3] * (1 - added[3]) / mix[3])); // green
  mix[2] = Math.round((added[2] * added[3] / mix[3]) + (base[2] * base[3] * (1 - added[3]) / mix[3])); // blue

  return "rgba("+mix.join(',')+")"
}
export default init
  